module.exports = __webpack_public_path__ + "img/medical_note.d10b4ad4.svg";